import { Box, Grid, Typography, styled, useTheme } from '@mui/material';
import Dialog from 'components/dialog';
import { ReactComponent as AquaXcel } from 'components/layout/assets/aqua-xcel-icon.svg';
import { useLayoutState } from 'components/layout/layout';
import { useThemeState } from 'contexts/theme/ThemeContext';
import Mui from 'materials';
import React from 'react';
import { FileChartColumnIncreasing, Layers } from 'lucide-react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import DeliveryBoardIcon from 'views/delivery-board/assets/delivery-board-icon';

import { AquaSpecies } from 'types/shared/aqua-species.type';
import image from '../assets/what-is-blu-viu-background.png';

type Props = {};

const StyledGrid = styled(Grid)(({ theme }) => ({
  gap: 4,
  justifyContent: 'center',
  alignContent: 'center',
  minHeight: '45%',
  boxShadow: '0px 1px 4px rgba(0,0,0,0.48)',
  backgroundImage: `linear-gradient(to bottom, rgba(255,255,255,0.05) 55%, ${theme.palette.darkBlue.main} 100%)`,
}));

const LinkBox: React.FC<Props> = ({}) => {
  const { aquaSpecies } = useThemeState();
  const intl = useIntl();
  const { handleSidebarToggle } = useLayoutState();
  const theme = useTheme();

  return (
    <Grid container height="400px" rowGap={4} spacing={4}>
      <StyledGrid size={6}>
        {aquaSpecies === AquaSpecies.shrimp ? (
          <Mui.Link
            component={Link}
            to={{ pathname: 'https://aquaxcel.com' }}
            target="_blank"
            rel="noreferrer"
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              width: '100%',
            }}>
            <AquaXcel />
          </Mui.Link>
        ) : (
          <Mui.Link
            component={Link}
            onClick={handleSidebarToggle}
            to={'/order-feed/supply-plan'}
            underline="none"
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              width: '100%',
            }}>
            <>
              <Layers size={30} color={theme.palette.blue.main} />
              <Typography color="white" fontWeight={'bold'} sx={{ mt: 2 }}>
                {intl.formatMessage({ id: 'features.orderFeed' })}
              </Typography>
            </>
          </Mui.Link>
        )}
      </StyledGrid>
      <StyledGrid size={6}>
        <Mui.Link
          component={Link}
          onClick={handleSidebarToggle}
          to={'/powerbi/reports'}
          underline="none"
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
          }}>
          <FileChartColumnIncreasing size={30} color={theme.palette.blue.main} />
          <Typography color="white" fontWeight={'bold'} sx={{ mt: 2 }}>
            {intl.formatMessage({ id: 'features.powerBi' })}
          </Typography>
        </Mui.Link>
      </StyledGrid>

      <StyledGrid size={12}>
        <>
          {aquaSpecies === AquaSpecies.salmon ? (
            <Mui.Link
              component={Link}
              onClick={handleSidebarToggle}
              to={'/delivery-board'}
              underline="none"
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
              }}>
              <DeliveryBoardIcon fill={theme.palette.blue.main} stroke={theme.palette.blue.main} />
              <Typography color="white" fontWeight={'bold'} sx={{ mt: 2 }}>
                {intl.formatMessage({ id: 'features.deliveryBoard' })}
              </Typography>
            </Mui.Link>
          ) : (
            <Box px={6}>
              <Typography variant="h3" color="white">
                {intl.formatMessage({ id: 'overview.dialog.title' })}
              </Typography>
              <Box borderTop={'solid white 1px'} mt={2}>
                <Typography
                  color="white"
                  sx={{ mt: 4, textOverflow: 'ellipsis', overflow: 'hidden', height: 45, whiteSpace: 'nowrap' }}>
                  <FormattedMessage id="overview.dialog.paragraphOne" />
                </Typography>
              </Box>
              <Dialog
                imageHeader={image}
                button={
                  <Typography sx={{ cursor: 'pointer', paddingTop: 2, zIndex: 7 }} align={'right'} color="white">
                    {intl.formatMessage({ id: 'overview.dialog.readMore' })}
                  </Typography>
                }
                title="">
                <Box>
                  <Typography mt={5} sx={{ borderBottom: '1px #012231 solid' }}>
                    <FormattedMessage id="overview.dialog.title" />
                  </Typography>
                  <Typography mt={5}>
                    <FormattedMessage id="overview.dialog.paragraphOne" />
                  </Typography>
                  <Typography mt={5}>
                    <FormattedMessage id="overview.dialog.paragraphTwo" />
                  </Typography>
                  <Typography mt={5}>
                    <FormattedMessage id="overview.dialog.paragraphThree" />
                  </Typography>
                  <Typography mt={5}>
                    <FormattedMessage id="overview.dialog.paragraphFour" />
                  </Typography>
                </Box>
              </Dialog>
            </Box>
          )}
        </>
      </StyledGrid>
    </Grid>
  );
};

export default React.memo(LinkBox);
